var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftCircleWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8617_39077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 4C17.2261 4 12.6477 5.89642 9.27208 9.27208C5.89642 12.6477 4 17.2261 4 22C4 26.7739 5.89642 31.3523 9.27208 34.7279C12.6477 38.1036 17.2261 40 22 40C26.7739 40 31.3523 38.1036 34.7279 34.7279C38.1036 31.3523 40 26.7739 40 22C40 17.2261 38.1036 12.6477 34.7279 9.27208C31.3523 5.89642 26.7739 4 22 4V4ZM29.875 20.875C30.1734 20.875 30.4595 20.9935 30.6705 21.2045C30.8815 21.4155 31 21.7016 31 22C31 22.2984 30.8815 22.5845 30.6705 22.7955C30.4595 23.0065 30.1734 23.125 29.875 23.125H16.8407L21.6715 27.9535C21.7761 28.0581 21.8591 28.1823 21.9157 28.3189C21.9723 28.4556 22.0014 28.6021 22.0014 28.75C22.0014 28.8979 21.9723 29.0444 21.9157 29.1811C21.8591 29.3177 21.7761 29.4419 21.6715 29.5465C21.5669 29.6511 21.4427 29.7341 21.3061 29.7907C21.1694 29.8473 21.0229 29.8764 20.875 29.8764C20.7271 29.8764 20.5806 29.8473 20.4439 29.7907C20.3073 29.7341 20.1831 29.6511 20.0785 29.5465L13.3285 22.7965C13.2237 22.692 13.1406 22.5679 13.0839 22.4312C13.0272 22.2945 12.998 22.148 12.998 22C12.998 21.852 13.0272 21.7055 13.0839 21.5688C13.1406 21.4321 13.2237 21.308 13.3285 21.2035L20.0785 14.4535C20.2897 14.2423 20.5763 14.1236 20.875 14.1236C21.1737 14.1236 21.4603 14.2423 21.6715 14.4535C21.8827 14.6647 22.0014 14.9513 22.0014 15.25C22.0014 15.5487 21.8827 15.8353 21.6715 16.0465L16.8407 20.875H29.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8617_39077",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8617_39077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8617_39077",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircleWhiteIcon);
export default __webpack_public_path__ + "static/media/arrow-left-circle-white-icon.5859d70a13390d48d2f6370494a3488d.svg";
export { ForwardRef as ReactComponent };